module.exports = __webpack_public_path__ + "static/media/3.876bf309.JPG";